import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {TypedForm, TypedFormOwnControls} from '../../../common/form-types';
import {WidgetImplSettingsComponentBase} from '../../components/widget-impl-settings-component-base';
import {DexWalletWidget} from '../dex-wallet-widget';
import {DexWalletWidgetSettings} from './dex-wallet-widget-settings';

interface SettingsFormValue {
    title: string;
}

@Component({
    selector:    'dex-wallet-widget-settings',
    templateUrl: './dex-wallet-widget-settings.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone:  false
})
export class DexWalletWidgetSettingsComponent extends WidgetImplSettingsComponentBase<DexWalletWidget> {

    @Input()
    public override widget: DexWalletWidget;

    public form: TypedForm<SettingsFormValue>;

    protected override buildForm(): void {
        const settings: DexWalletWidgetSettings = this.widget.implementationInstance.settings;

        const controls: TypedFormOwnControls<SettingsFormValue> = {
            title:   this.createTitleFormControl(settings)
        };

        this.form = new FormGroup(controls) as TypedForm<SettingsFormValue>;
    }

}
